import React, { Component } from 'react'
import { Button, Modal } from 'semantic-ui-react'

export default class AgreementModal extends Component {
    render() {
        return (
            <div>
                <Modal
                    onClose={this.props.onClose}
                    open={this.props.open}
                >
                    <Modal.Header>Agreement Acknowledgement</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            {/* <embed src="../../ag.pdf#toolbar=0&navpanes=0&scrollbar=0" type="application/pdf" width="100%" height="600px" /> */}
                            <object width="100%" height="400" data="../../ag.pdf" type="application/pdf">   </object>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>

                        <Button size="mini" onClick={this.props.onClose} positive>
                            Ok
                            </Button>
                    </Modal.Actions>
                </Modal>
            </div>
        )
    }
}
